<template>
    <div class="">
        <new-modal
            title=""
            :show-header="false"
            :start-open="startOpen"
            size="4xl"
        >
            <template #trigger>
                <span class="btn btn-success inline-block">{{
                    buttonText
                }}</span>
            </template>
            <template #content>
                <div class="mb-8 mt-4 text-center">
                    <div class="text-[20px] font-bold">
                        You have no active subscription.
                    </div>
                    <div class="text-[14px] font-semibold text-neutral-60">
                        Add a subscription to begin studying with EMTprep
                    </div>
                </div>

                <div class="">
                    <div class="m-4 md:m-0">
                        <div
                            class="mx-auto flex w-auto max-w-[50rem] flex-col justify-between gap-4 md:mb-0 md:flex-row"
                        >
                            <div
                                class="flex w-full flex-col rounded border border-gray-200 bg-gray-50 p-8 text-center text-[18px] md:h-[22rem] md:w-[24rem]"
                            >
                                <div
                                    class="mb-4 border-b border-gray-200 pb-4 font-semibold"
                                >
                                    Monthly Membership
                                </div>
                                <div class="">
                                    Monthly auto-renew, billed every month.
                                    Cancel anytime.
                                </div>
                                <div
                                    class="mb-auto mt-auto flex items-center justify-center gap-1"
                                >
                                    <span class="text-[36px] font-semibold"
                                        >$39</span
                                    ><span>/month</span>
                                </div>
                                <div class="mt-auto">
                                    <Link
                                        :href="
                                            route(
                                                'frontend.student.show-register-payment-form',
                                                {
                                                    existing_student: true,
                                                    plan: 'monthly',
                                                }
                                            )
                                        "
                                        class="btn btn-lg btn-primary !font-medium"
                                    >
                                        Get started (monthly)
                                    </Link>
                                </div>
                            </div>
                            <div
                                class="flex flex-col rounded bg-gray-900 p-8 text-center text-[18px] text-white md:h-[22rem] md:w-[24rem]"
                            >
                                <div
                                    class="mb-4 border-b border-gray-800 pb-4 font-semibold"
                                >
                                    Annual Membership
                                </div>
                                <div class="">
                                    Membership for 1 year. One-time payment.
                                    <span class="text-secondary-500"
                                        >Save 35%</span
                                    >.
                                </div>
                                <div
                                    class="mb-auto mt-auto flex items-center justify-center gap-1"
                                >
                                    <span class="text-[36px] font-semibold"
                                        >$299</span
                                    ><span>/year</span>
                                </div>
                                <div class="mt-auto">
                                    <Link
                                        :href="
                                            route(
                                                'frontend.student.show-register-payment-form',
                                                {
                                                    existing_student: true,
                                                    plan: 'annual',
                                                }
                                            )
                                        "
                                        class="btn btn-lg border-dark-mode-stroke bg-dark-mode-fill !font-medium hover:bg-dark-mode-highlight"
                                    >
                                        Get started (1 year)
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </new-modal>
    </div>
</template>

<script>
import PurchaseSubscriptionForm from "./PurchaseSubscriptionForm";
import NewModal from "@/Components/NewModal.vue";

export default {
    name: "NoSubscriptionModal",
    components: {
        NewModal,
        PurchaseSubscriptionForm,
    },
    props: {
        startOpen: {
            type: Boolean,
            default: true,
        },
        buttonText: {
            type: String,
            default: "Start Subscription",
        },
    },
    data() {
        return {
            showModal: this.startOpen,
        };
    },
};
</script>

<style scoped></style>
